import React from "react";

export default () => {

    return <svg xmlns="http://www.w3.org/2000/svg" width="60.879" height="60.879" viewBox="0 0 60.879 60.879">
        <path d="M35.119,31.817,27.407,24.1l7.712-7.712a2.339,2.339,0,1,0-3.307-3.307L24.1,20.8l-7.712-7.712a2.339,2.339,0,0,0-3.307,3.307L20.792,24.1,13.08,31.817a2.261,2.261,0,0,0,0,3.307,2.323,2.323,0,0,0,3.307,0L24.1,27.412l7.712,7.712a2.35,2.35,0,0,0,3.307,0A2.323,2.323,0,0,0,35.119,31.817Z" transform="translate(6.34 6.335)"/>
        <path d="M33.814,7.473a26.346,26.346,0,0,1,18.63,44.971A26.346,26.346,0,0,1,15.185,15.185a26.168,26.168,0,0,1,18.63-7.712m0-4.1A30.439,30.439,0,1,0,64.254,33.814,30.435,30.435,0,0,0,33.814,3.375Z" transform="translate(-3.375 -3.375)"/>
    </svg>;

}
